<td class="balance-benefit-row__label mat-mdc-cell">
  {{ labelKey | translate }}
</td>
<td class="balance-benefit-row__cells mat-mdc-cell">
  <mmx-balance-benefit-cell
    [label]="'balance.benefits.primary-label' | translate"
    [control]="primaryControl"
    [format]="format"
    [originalValue]="originalPrimary"
    [ambiguous]="ambiguousPrimary"
    (committed)="onCellCommitted()">
  </mmx-balance-benefit-cell>

  <mmx-balance-benefit-cell
    *ngIf="hasSecondary && secondaryControl"
    [label]="'balance.benefits.secondary-label' | translate"
    [control]="secondaryControl"
    [format]="format"
    [originalValue]="originalSecondary"
    [ambiguous]="ambiguousSecondary"
    (committed)="onCellCommitted()">
  </mmx-balance-benefit-cell>
</td>
